export enum HawkerCommissaryAssignmentForm {
  HawkerManager = 'OXpt',
  NoCommissary = '2I0Y',
  NoAvailableManagers = 'JPeo',
  HighlightedManagerNoLongerAvailable = 'eEnt',
}
